<lib-challenges-widget 
  class="standalone-widget"
  [challenges]="data.contents" 
  [textColor]="data.defaultTextColor"
  (joinChallenge)="joinChallenge($event)"
  (navigateToChallenge)="navigateToChallenge($event)">
</lib-challenges-widget>